import React, { Component } from 'react'
import ReactToPrint from "react-to-print";
import XLSXToData from './XLSXToData';
export default class ReportPrint extends Component {
componentRef = null;


constructor(props) {
  super(props);
  this.state = {
   
    PrintBtn:true
  };

}componentDidMount(){


}

  render() {
    return (
      <div className='d-flex justify-content-center flex-column py-3'>
      {/* button to trigger printing of target component */}
      {this.state.PrintBtn&&<ReactToPrint
        trigger={() => <button  className='btn btn-primary p-2 d-print-none'>Print this out!</button>}
        content={() => this.componentRef}
        documentTitle="School Base Assesment"
        onAfterPrint={() => {}}
        onBeforeGetContent={() => {}}
        onBeforePrint={() => {}}
        pageStyle="
        @page {
          size: A4;
        }"
        
        removeAfterPrint
        
      />}

      {/* component to be printed */}
      <XLSXToData ref={(el) => (this.componentRef = el)} />
      
      
    </div>
    )
  }
}
